<template>
  <div class="form-container">
    <div class="form-inner">
      <p class="form-subtitle">
        Si deseas solicitar una cotización, déjanos tus comentarios en el
        formulario de contacto.
      </p>

      <!-- Apunta al backend PHP -->
      <form
        action="/send.php"
        method="POST"
        id="form"
        class="needs-validation"
        novalidate
      >
        <!-- Honeypot anti-bots -->
        <input type="checkbox" name="botcheck" style="display: none" />

        <!-- Nombre y Apellido (ahora con name="…") -->
        <div class="form-row">
          <div class="form-group">
            <label for="fname"
              >Nombre <span class="required-asterisk">*</span></label
            >
            <input
              id="fname"
              name="nombre"
              maxlength="20"
              required
              placeholder="Tu Nombre"
            />
            <div class="invalid-feedback">
              Solo letras, máximo 20 caracteres.
            </div>
          </div>

          <div class="form-group">
            <label for="lname"
              >Apellido <span class="required-asterisk">*</span></label
            >
            <input
              id="lname"
              name="apellido"
              maxlength="20"
              required
              placeholder="Tu Apellido"
            />
            <div class="invalid-feedback">
              Solo letras, máximo 20 caracteres.
            </div>
          </div>
        </div>

        <!-- Correo y Teléfono -->
        <div class="form-row">
          <div class="form-group">
            <label for="email"
              >Correo Electrónico
              <span class="required-asterisk">*</span></label
            >
            <input
              type="email"
              id="email"
              name="correo"
              maxlength="30"
              required
              placeholder="correo@ejemplo.com"
            />
            <div class="invalid-feedback">Correo electrónico no válido.</div>
          </div>

          <div class="form-group">
            <label for="phone"
              >Teléfono <span class="required-asterisk">*</span></label
            >
            <input
              id="phone"
              name="telefono"
              maxlength="12"
              required
              placeholder="+56912345678"
            />
            <div id="phoneError" class="invalid-feedback telefono-feedback">
              Debe comenzar con +569 y seguir con 8 dígitos.
            </div>
          </div>
        </div>

        <!-- Empresa y RUT -->
        <div class="form-row">
          <div class="form-group">
            <label for="empresa">Empresa o Razón Social</label>
            <input
              id="empresa"
              name="empresa"
              maxlength="30"
              placeholder="Rodamientos S.A."
            />
          </div>

          <div class="form-group">
            <label for="rut"
              >RUT <span class="required-asterisk">*</span></label
            >
            <input
              id="rut"
              name="rut"
              maxlength="12"
              required
              placeholder="12345678-K"
            />
            <div class="invalid-feedback">
              Agrega un RUT válido con guión y dígito verificador
            </div>
          </div>
        </div>

        <!-- Productos seleccionados -->
        <div v-if="productosSeleccionados.length" class="productos-box">
          <h3 class="productos-title">Unidades a Cotizar</h3>
          <div class="productos-grid">
            <div
              v-for="p in productosSeleccionados"
              :key="p.slug"
              class="producto-item"
            >
              <img :src="p.imagen" :alt="p.nombre" />
              <span>{{ p.nombre }}</span>
            </div>
          </div>
        </div>

        <!-- Campo oculto para JSON de productos -->
        <input type="hidden" id="productosHidden" name="productos" />

        <!-- Mensaje -->
        <div class="form-group">
          <label for="message">Su Mensaje</label>
          <textarea
            rows="5"
            id="message"
            name="mensaje"
            required
            placeholder="Escriba aquí su consulta o solicitud de cotización"
          ></textarea>
          <div class="invalid-feedback">Este campo es obligatorio.</div>
        </div>

        <!-- Botón -->
        <div class="form-button">
          <button type="submit">Enviar Mensaje</button>
        </div>
        <p class="form-result" id="result"></p>
      </form>
    </div>
  </div>
</template>

<script>
import { storeToRefs } from "pinia";
import { useCotizacionStore } from "@/store/cotizacion";

export default {
  name: "FormularioCotizacion",
  setup() {
    const { productosSeleccionados } = storeToRefs(useCotizacionStore());
    return { productosSeleccionados };
  },
  mounted() {
    const form = document.getElementById("form");
    if (form) {
      form.reset();
      form.classList.remove("was-validated");
    }
    this.initLiveValidation();
    this.initFormValidation();
  },
  methods: {
    /* ---------- Validación en tiempo real ---------- */
    initLiveValidation() {
      const regex = {
        fname: /^[A-Za-zÁÉÍÓÚáéíóúÑñ\s]{1,20}$/,
        lname: /^[A-Za-zÁÉÍÓÚáéíóúÑñ\s]{1,20}$/,
        email: /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/,
        phone: /^\+569\d{8}$/,
        rut: /^[0-9]{7,8}-[kK0-9]$/,
      };
      Object.entries(regex).forEach(([id, rgx]) => {
        const el = document.getElementById(id);
        if (!el) return;
        el.addEventListener("input", () => {
          if (id === "fname" || id === "lname")
            el.value = el.value.replace(/[^A-Za-zÁÉÍÓÚáéíóúÑñ\s]/g, "");
          if (id === "phone")
            el.value = el.value.replace(/[^+0-9]/g, "").slice(0, 12);
          if (id === "rut") {
            let v = el.value.replace(/[^0-9kK-]/g, "");
            const p = v.split("-");
            if (p.length > 2) v = p[0] + "-" + p[1];
            if (v.startsWith("-")) v = v.slice(1);
            el.value = v;
          }
          el.classList.toggle("is-valid", rgx.test(el.value.trim()));
          if (id === "phone")
            document.getElementById("phoneError").style.display = "none";
        });
      });
    },

    /* ---------- Validación y envío ---------- */
    initFormValidation() {
      const form = document.getElementById("form");
      const result = document.getElementById("result");

      form.addEventListener("submit", (e) => {
        e.preventDefault();
        e.stopPropagation();

        /* refs */
        const nombre = document.getElementById("fname");
        const apellido = document.getElementById("lname");
        const email = document.getElementById("email");
        const telefono = document.getElementById("phone");
        const rut = document.getElementById("rut");
        /*const empresa = document.getElementById("empresa");*/
        /*const mensaje = document.getElementById("message");*/
        const phoneErr = document.getElementById("phoneError");

        /* validación rápida */
        const regex = {
          nombre: /^[A-Za-zÁÉÍÓÚáéíóúÑñ\s]{1,20}$/,
          apellido: /^[A-Za-zÁÉÍÓÚáéíóúÑñ\s]{1,20}$/,
          email: /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/,
          telefono: /^\+569\d{8}$/,
          rut: /^[0-9]{7,8}-[kK0-9]$/,
        };

        let ok = true;
        const comprobar = (el, rgx) => {
          const valido = rgx.test(el.value.trim());
          el.classList.toggle("is-invalid", !valido);
          el.classList.toggle("is-valid", valido);
          if (!valido) ok = false;
        };

        comprobar(nombre, regex.nombre);
        comprobar(apellido, regex.apellido);
        comprobar(email, regex.email);
        comprobar(rut, regex.rut);

        if (!regex.telefono.test(telefono.value.trim())) {
          telefono.classList.add("is-invalid");
          phoneErr.style.display = "block";
          ok = false;
        } else {
          telefono.classList.remove("is-invalid");
          telefono.classList.add("is-valid");
        }

        if (!ok) {
          form.classList.add("was-validated");
          return;
        }

        /* ---------- preparar JSON de productos ---------- */
        const agrupados = {};
        this.productosSeleccionados.forEach((p) => {
          const cat = p.categoria || "Otros";
          if (!agrupados[cat]) agrupados[cat] = [];
          agrupados[cat].push(p.nombre);
        });
        document.getElementById("productosHidden").value =
          JSON.stringify(agrupados);

        /* ---------- enviar con FormData ---------- */
        result.textContent = "Enviando…";
        const fd = new FormData(form);

        fetch("/send.php", {
          method: "POST",
          body: fd,
        })
          .then((r) => r.json())
          .then(({ ok, msg }) => {
            result.textContent =
              msg ||
              (ok
                ? "Enviado correctamente. Por favor, esté atento a nuestra respuesta en su correo."
                : "Error al enviar cotización");
            result.className = ok
              ? "form-result text-green-500"
              : "form-result text-red-500";
          })
          .catch(() => { 
            result.textContent = "¡Algo salió mal!";
            result.className = "form-result text-red-500";
          })
          .finally(() => {
            form.reset();
            form.classList.remove("was-validated");
            [nombre, apellido, email, telefono, rut].forEach((el) =>
              el.classList.remove("is-valid")
            );
            setTimeout(() => (result.textContent = ""), 7000); //Duracion del mensaje
          });
      });
    },
  },
};
</script>

<style scoped>
/* base */
.form-group input.is-valid {
  border-color: #198754;
}
.form-group input.is-invalid {
  border-color: #dc3545;
}
.invalid-feedback {
  display: none;
  color: #dc3545;
  font-size: 0.875rem;
  margin-top: 0.25rem;
}
input.is-invalid + .invalid-feedback {
  display: block;
}
input.is-valid + .invalid-feedback {
  display: none;
}
/* --- Formulario base --- */
.form-container {
  background-color: #f8f8f8;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  margin: 0 auto;
  max-width: 800px;
}
.form-inner {
  padding: 2rem;
}
.form-subtitle {
  text-align: center;
  color: #666;
  margin-bottom: 2rem;
}
.form-row {
  display: flex;
  gap: 20px;
  margin-bottom: 1.5rem;
}
.form-group {
  flex: 1;
  margin-bottom: 1.5rem;
  position: relative;
}
.form-group label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  color: #333;
}
.form-group input,
.form-group textarea {
  width: 100%;
  padding: 0.75rem;
  border: 2px solid #e2e2e2;
  border-radius: 6px;
  background-color: #fff;
  transition: border-color 0.3s;
}
.form-group input:focus,
.form-group textarea:focus {
  outline: none;
  border-color: #3b5998;
  box-shadow: 0 0 0 3px rgba(59, 89, 152, 0.1);
}

.empty-feedback,
.invalid-feedback {
  display: none;
  color: #dc3545;
  font-size: 0.875rem;
  margin-top: 0.25rem;
}
.was-validated input:invalid + .invalid-feedback,
.was-validated textarea:invalid + .invalid-feedback {
  display: block;
}

/* resaltar borde rojo */
.was-validated :invalid {
  border-color: #dc3545;
}

.form-button {
  margin-top: 1rem;
}
.form-button button {
  width: 100%;
  padding: 0.875rem;
  background-color: #3b5998;
  color: white;
  border: none;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s;
}
.form-button button:hover {
  background-color: #344e86;
}
.form-result {
  text-align: center;
  margin-top: 1rem;
  font-weight: 500;
}

/* --- Productos seleccionados --- */
.productos-title {
  text-align: center;
  font-size: 1.2rem;
  margin-bottom: 1rem;
}
.productos-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(90px, 1fr));
  gap: 1rem;
}
.producto-item {
  text-align: center;
  background-color: #fafafa;
  border-radius: 6px;
  padding: 0.5rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}
.producto-item img {
  max-width: 100%;
  height: 60px;
  object-fit: contain;
}
.producto-item span {
  display: block;
  margin-top: 0.25rem;
  font-size: 0.85rem;
  color: #333;
}

/* --- Responsive --- */
@media (max-width: 768px) {
  .form-row {
    flex-direction: column;
  }
  .producto-item img {
    height: 50px;
  }
}

.required-asterisk {
  color: #ff6600;
  margin-left: 2px;
}

.productos-box {
  border: 2px solid #ddd;
  border-radius: 8px;
  padding: 1rem;
  margin: 1.5rem 0;
  background-color: #fff;
}

/* ---------- TELÉFONO ---------- */
.phone-input-group {
  display: flex;
  align-items: center;
  width: 100%;
}

.prefix {
  background-color: #eee;
  padding: 0.75rem;
  border: 2px solid #e2e2e2;
  border-right: none;
  border-radius: 6px 0 0 6px;
  font-size: 0.95rem;
  color: #555;
  height: 48px;
  flex: 0 0 auto;
}

.phone-input-group input {
  flex: 1 1 auto;
  padding: 0.75rem;
  border: 2px solid #e2e2e2;
  border-left: none;
  border-radius: 0 6px 6px 0;
  background-color: #fff;
  height: 48px;
  min-width: 0;
}

/* feedback teléfono */
.telefono-feedback {
  background-color: #ffeaea;
  border-left: 4px solid #dc3545;
  padding: 0.5rem;
  border-radius: 4px;
  margin-top: 0.5rem;
  font-size: 0.85rem;
}

/* Mostrar feedback: usamos :has() (Chrome/Edge/Firefox modernos) */
.phone-input-group:has(input:invalid) + .telefono-feedback {
  display: block;
  animation: fadeIn 0.3s ease-in-out;
}

/* fallback JS: añade clase is-invalid al input ⇒ lo cubrimos también */
.phone-input-group input.is-invalid ~ .telefono-feedback {
  display: block;
  animation: fadeIn 0.3s ease-in-out;
}

/* Animación */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-3px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
